/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link } from '@coursera/event-pulse/react';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import { useIntl } from 'bundles/page/lib/useIntl';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';
import { COURSE_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

import _t from 'i18n!nls/xdp';

type Props = { moduleCount?: number; title?: string; subtitle?: string; anchorId?: string };

const styles = {
  link: css`
    /* override cds link color */
    color: var(--cds-color-neutral-primary) !important;
  `,
  inline: css`
    display: inline;
  `,
};

const KeyInformationModuleCount = ({ moduleCount, title, subtitle, anchorId }: Props): React.ReactElement | null => {
  const eventingProductData = useEventingProductData();
  const intl = useIntl();

  let moduleTitle = title;
  if (!moduleCount && !moduleTitle) {
    return null;
  }

  if (moduleCount && !moduleTitle) {
    moduleTitle = intl.formatMessage(_t('{moduleCount} {moduleCount, plural, =1 {module} other {modules}}'), {
      moduleCount,
    });
  }

  return (
    <KeyInformationDetailsItem
      title={
        <TrackedDiv trackingName="kim_view_syllabus" css={styles.inline}>
          <Link
            href={`#${anchorId ?? COURSE_NAV_ITEMS.MODULES}`}
            typographyVariant="subtitleLarge"
            trackingData={{
              button: { name: 'description_page_view_syllabus' },
              pageSection: {
                sectionName: 'kim',
              },
              ...eventingProductData,
            }}
            noViewTracking
            css={styles.link}
          >
            {moduleTitle}
          </Link>
        </TrackedDiv>
      }
      subtitle={subtitle ?? _t('Gain insight into a topic and learn the fundamentals.')}
      modalTitle={moduleTitle}
    />
  );
};

export default KeyInformationModuleCount;
